import React from 'react';
interface PageHeaderProps {
  eyebrow: string;
  title: string;
  body?: string;
}
export function PageHeader({
  eyebrow,
  title,
  body
}: PageHeaderProps) {
  return <section className="relative overflow-hidden border-b border-white/5 bg-ink-900" data-id="element-170" data-mp="3cjpga7faj0xy">
      <div aria-hidden="true" className="pointer-events-none absolute inset-0 opacity-[0.05]" style={{
      backgroundImage: 'linear-gradient(to right, #ffffff 1px, transparent 1px), linear-gradient(to bottom, #ffffff 1px, transparent 1px)',
      backgroundSize: '72px 72px'
    }} data-id="element-171" data-mp="3rcj90ujkpdkk" />
      <div className="relative mx-auto max-w-content px-5 py-16 sm:px-8 sm:py-24" data-id="element-172" data-mp="38g9oppi2vqs4">
        <p className="text-xs font-semibold uppercase tracking-[0.18em] text-brand" data-id="element-173" data-mp="33pb5ah1smckn">
          {eyebrow}
        </p>
        <h1 className="mt-5 max-w-3xl font-display text-3xl font-bold leading-[1.1] tracking-tight text-white sm:text-5xl" data-id="element-174" data-mp="2fyxdmrn4efql">
          {title}
        </h1>
        {body && <p className="mt-6 max-w-2xl text-base leading-relaxed text-white/65 sm:text-lg" data-id="element-175" data-mp="2hyycx4rwzkz7">
            {body}
          </p>}
      </div>
    </section>;
}